import { OTHER_ACTIONS } from '../../constants.js';

export function updateInfoWB(workItem) {
  return {
    type: OTHER_ACTIONS.UPDATE_WB_INFO,
    workBarAction: workItem
  };
}

export function callMark() {
  return {
    type: OTHER_ACTIONS.MARK_CALL,
  };
}

export function resetMarks() {
  return {
    type: OTHER_ACTIONS.RESET_MARKS,
  };
}
export function deleteChatNotifications() {
  return {
    type: OTHER_ACTIONS.DELETE_CHAT_NOTIFICATIONS,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/A_other_actions.js